/**
 * MSAL Configuration for Azure B2C Authentication
 *
 * This configuration is used by the Blocks Frame AppShell component
 * to handle user authentication with Microsoft Azure B2C.
 */

export interface MSALConfig {
  clientId: string;
  redirectURL: string;
  postLogoutRedirectUri: string;
  policy: string;
}

/**
 * Validates required environment variables
 * @throws Error if required environment variables are missing
 */
const validateEnvVariables = (): void => {
  const requiredEnvVars = {
    VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
    VITE_REDIRECT_URL: import.meta.env.VITE_REDIRECT_URL,
    VITE_POST_LOGOUT_REDIRECT_URI: import.meta.env
      .VITE_POST_LOGOUT_REDIRECT_URI,
  };

  const missingVars = Object.entries(requiredEnvVars)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(", ")}`,
    );
  }
};

// Validate environment variables in development
if (import.meta.env.DEV) {
  validateEnvVariables();
}

export const msalConfig: MSALConfig = {
  clientId: import.meta.env.VITE_CLIENT_ID || "",
  redirectURL: import.meta.env.VITE_REDIRECT_URL || "",
  postLogoutRedirectUri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || "",
  policy: import.meta.env.VITE_POLICY || "b2c_1a_p2_v1_signin_prod",
};
